import {gql} from "@irati/utils/gql"

import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import fullUser from "../fragments/fullUserV4"
import fullTeamV4 from "../fragments/fullTeamV4"

const query = gql`
  mutation CreateUser($user: NewUserInput!, $withTeams: Boolean!) {
    createUser(user: $user) {
      ...fullUser
      teams @include(if: $withTeams) {
        results {
          ...fullTeam
        }
      }
    }
  }
  ${fullUser}
  ${fullTeamV4}
`

export const createUserKey = getQueryNames(query)[0]

export default query
